import { CartActionTypes, CartReducerAction, CartReducerActionType } from '../../app/(routes)/online-ordering/types';

export const createActions = (
  dispatch: (action: CartReducerAction, callback?: (state: CartActionTypes) => void) => Promise<void>
) => {
  return {
    syncCart: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.SyncCart, data: payload }, callback),
    saveAndSyncCart: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.SaveAndSyncCart, data: payload }, callback),
    syncLocalCart: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.SyncLocalCart, data: payload }, callback),
    addToCart: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.AddToCart, data: payload }, callback),
    removeFromCart: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.RemoveFromCart, data: payload }, callback),
    updateToCart: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.UpdateInCart, data: payload }, callback),
    incrementQuantityInCart: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.IncrementInCart, data: payload }, callback),
    incrementCartItem: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.incrementCartItem, data: payload }, callback),
    decrementQuantityInCart: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.DecrementInCart, data: payload }, callback),
    saveCart: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.SaveCart, data: payload }, callback),
    deleteItem: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.DeleteItem, data: payload }, callback),
    reorderItems: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.ReorderItems, data: payload }, callback),
    toggleCartOption: (payload?: CartActionTypes) =>
      dispatch({ type: CartReducerActionType.ToggleCartOption, data: payload }),
    setState: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.SetState, data: payload }, callback),
    reset: (payload?: CartActionTypes) => dispatch({ type: CartReducerActionType.Reset, data: payload }),
    addDealItems: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.AddDealItems, data: payload }, callback),
    removeDealItems: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.RemoveDealItems, data: payload }, callback),
    checkDecrementPricing: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.CheckDecrementPricing, data: payload }, callback),
    checkDeletePricing: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.CheckDeletePricing, data: payload }, callback),
    checkUpdatePricing: (payload?: CartActionTypes, callback?: (state: CartActionTypes) => void) =>
      dispatch({ type: CartReducerActionType.CheckUpdatePricing, data: payload }, callback),
  };
};
